function datetimeFilter($translate, bbTimeZone, GeneralOptions) {
    'ngInject';

    return function (date, format, showTimeZone, timeZoneToConvert) {

        let timeZone = '';

        if (format === 'configuration') {
            format = GeneralOptions.datetimeFormat;

            // Override showTimeZone parameter if it was passed and set in configuration at the same time.
            showTimeZone = ['Z', '+', '-'].some(character => format.includes(character));
        } else {
            // FIXME: It's for not braking things. Format should be loaded from configuration and not be hard coded.
            format = format || 'LLL';
        }

        if (!date || (date && !moment(date).isValid())) {
            return;
        }

        const newDate = moment(date);

        // use the display timezone unless a timeZoneToConvert has been passed in
        if (timeZoneToConvert) {
            newDate.tz(timeZoneToConvert);
        } else {
            newDate.tz(bbTimeZone.getDisplay());
        }

        if (showTimeZone) {
            timeZone = `(${$translate.instant(`I18N.TIMEZONE_LOCATIONS.CODES.${newDate.format('zz')}`)})`;
        }

        return `${newDate.format(format)} ${timeZone}`;
    };
}

/**
 * @ngdoc filter
 * @name datetime
 * @kind function
 *
 * @description
 * Format given moment object or datelike string using provided format.
 *
 * @param {moment|string} date The date to format
 * @param {string} format The format to apply. Defaults to configured value.
 * @param {boolean} showTimeZone Whether or not to display the time zone
 * @param {string} timeZoneToConvert The time zone to convert to
 *
 *
 * <example module="dateTimeExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('dateTimeExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.date = moment();
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <span>Date: {{date | datetime}}</span>
 *     </div>
 *   </file>
 * </example>
 */
angular
    .module('BB')
    .filter('datetime', datetimeFilter);



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_filters/datetime.filter.js